import { Sigma } from "lucide-react";

const INPUT_ORDER = ["ph", "temperature", "alkalinity", "calcium_hardness", "tds"];

export function LsiCalculationCard({ lsi }) {
  if (!lsi) return null;
  const calculated = lsi.status === "calculated";
  return (
    <section data-testid="lab-lsi-card" className="rounded-3xl bg-white border border-slate-200 p-6">
      <div className="flex items-center gap-2 mb-1">
        <Sigma className="w-4 h-4 text-cyan-700" />
        <h2 className="font-bold text-slate-900">LSI Calculation</h2>
        <span className="rounded-full bg-slate-100 text-slate-500 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider">
          Calculated index · {lsi.formula_version}
        </span>
      </div>
      <p className="text-xs text-slate-500 mb-4">
        Langelier Saturation Index computed from this sample's measured results. Recalculates automatically whenever results are saved.
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 mb-4">
        {INPUT_ORDER.map((k) => {
          const inp = (lsi.inputs || {})[k] || {};
          const has = inp.value !== null && inp.value !== undefined;
          return (
            <div key={k} className="rounded-xl border border-slate-200 bg-slate-50/60 p-3" data-testid={`lsi-input-${k}`}>
              <div className="text-[10px] uppercase tracking-wider font-bold text-slate-400">{inp.label || k}</div>
              <div className={`font-semibold mt-0.5 ${has ? "text-slate-900" : "text-rose-500"}`}>
                {has ? `${inp.value} ${inp.unit || ""}` : "Missing"}
              </div>
              {has && inp.source && inp.source !== "measured" && (
                <div className="text-[10px] text-amber-600 mt-0.5">derived from Calcium × 2.497</div>
              )}
            </div>
          );
        })}
      </div>
      {calculated ? (
        <div className="flex flex-wrap items-center gap-3">
          <div className="text-sm font-semibold text-slate-500">Calculated LSI:</div>
          <div className="text-2xl font-bold text-slate-900" data-testid="lab-lsi-value">{lsi.value.toFixed(2)}</div>
          <p className="text-xs text-slate-500 w-full">{lsi.interpretation}</p>
        </div>
      ) : (
        <div className="rounded-xl bg-rose-50 border border-rose-200 px-4 py-3 text-sm text-rose-700" data-testid="lab-lsi-missing">
          Not calculated — insufficient analytical data. Missing: {(lsi.missing || []).join(", ")}
        </div>
      )}
    </section>
  );
}
